<template>
  <div>
    <headnavigation :flow="flow" />
    <hr />
    <staff />
  </div>
</template>
<script>

//load the form for creating and editing staff
import StaffForm from "../../../components/lmt/StaffForm";

export default {
  components: {
    staff: StaffForm
  },
  data() {
    return {
      flow: [
        { text: "Staff Accounts", link: "/lmt/staff" },
        { text: "Create Staff Account" }
      ]
    };
  }
};
</script>